/* DuplicateSourceError.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._1UtDYzAyGJ%7Bcolor%3Avar(--ds-text-danger%2C%23ae2e24)%7D");




import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Box } from '@atlaskit/primitives/compiled/box';
const messages = defineMessages({
  duplicateSourceError: {
    id: 'rovo.spaces.sourceLinkPicker.duplicateSourceError',
    defaultMessage: 'This source is already added.',
    description: 'Error shown in the link picker footer when the user tries to add a source that is already in the space.'
  }
});
const styles = {
  root: "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzAyGJ"
};
export const DuplicateSourceError = (): React.JSX.Element => {
  const intl = useIntl();
  return <Box as="span" xcss={styles.root}>
			<StatusErrorIcon label="" color="currentColor" size="small" />
			{intl.formatMessage(messages.duplicateSourceError)}
		</Box>;
};